import React, { useState } from "react";
import { Form, Select, DatePicker, Button, Tooltip, Switch } from "antd";
import styled from "styled-components";
import dayjs from 'dayjs'

import { TableOutlined } from "@ant-design/icons";

const StyledForm = styled(Form)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 12px;
  flex-wrap: wrap;

  & .ant-select-selector {
    width: 80px !important;
  }

  & .ant-select-selection-item {
    text-transform: capitalize !important;
  }
 `;

const FilterInputs = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 20px;
  flex-wrap: wrap;
`;

const FilterActions = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 10px;
`;

const StyledDatePicker = styled(DatePicker)`
  background: white;
  width: 100%;
  > .ant-picker-input .ant-picker-clear:hover {
    color: unset !important;
  }
`;

const StyledSelect = styled(Select)`
  & .ant-select-selector {
    width: 100% !important;
  }
`

const AllocatedFilter = ({ 
  isPhysicianReport,
  activeProviderState,
  setActiveProviderState,
  onSearch,
  onExportToXLSX,
  onExportToPDF,
  hasData
}) => {
  const [date, setDate] = useState(dayjs().subtract(1, 'month').startOf('month'))
  const [filterType, setFilterType] = useState("month")

  const handleSearch = () => {
    onSearch({ filterType, date })
  }
  
  return (
    <StyledForm>
      <FilterInputs>
        <Form.Item name="type" label="Period" style={{ width: '150px', marginBottom: 0 }}>
          <StyledSelect id="report-filter-period-select" defaultValue={filterType} onChange={val => setFilterType(val)}>
            <Select.Option value="date">Date</Select.Option>
            <Select.Option value="week" >Week</Select.Option>
            <Select.Option value="month">Month</Select.Option>
            <Select.Option value="year">Year</Select.Option>
          </StyledSelect>
        </Form.Item>
        <Form.Item name="pickerValue" style={{ textTransform: 'capitalize', marginBottom: 0 }} label={filterType}>
          <StyledDatePicker
            id="report-filter-date-picker"
            defaultValue={date}
            picker={filterType}
            onChange={val => setDate(val)}
            allowClear={false}
          />
        </Form.Item>
        {isPhysicianReport && (
          <Form.Item name="inactive" label="Active" style={{ marginBottom: 0 }}>
            <Switch id="report-filter-active-provider-switch" checked={activeProviderState} onChange={val => setActiveProviderState(val)} />
          </Form.Item>
        )}
      </FilterInputs>
      <FilterActions>
        <Form.Item style={{ marginBottom: 0 }}>
          <Button id="report-filter-search-btn" type='primary' onClick={handleSearch}>Search</Button>
        </Form.Item>
        <Form.Item style={{ marginBottom: 0 }}>
          <Tooltip title="Export to XSLX">
            <Button id="report-export-xlsx-btn" type='primary' onClick={onExportToXLSX} disabled={!hasData}><TableOutlined /></Button>
          </Tooltip>
        </Form.Item>
      </FilterActions>
    </StyledForm>
  );
};

export default AllocatedFilter;
